import React, { Component } from "react";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import MatchDaysTable from "./matchDaysTable";
import { getMatchDays, deleteMatchDay } from "../../services/matchDayService";
import "react-confirm-alert/src/react-confirm-alert.css";
import _ from "lodash";

class MatchDays extends Component {
  state = { matchDays: [], sortColumn: { key: "name", order: "asc" } };

  async componentDidMount() {
    const matchDays = await getMatchDays();
    this.setState({ matchDays });
  }

  handleDelete = async matchDay => {
    confirmAlert({
      title: "Delete MatchDay",
      message: "Are you sure you want to delete '" + matchDay.name + "'?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const matchDays = this.state.matchDays.filter(
              s => s.id !== matchDay.id
            );
            this.setState({ matchDays });

            await deleteMatchDay(matchDay.id);
          }
        },
        {
          label: "No",
          onClick: () => {}
        }
      ]
    });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn });
  };

  getSortedData = () => {
    const { matchDays, sortColumn } = this.state;
    const sorted = _.orderBy(matchDays, [sortColumn.key], [sortColumn.order]);
    return { matchDays: sorted };
  };

  render() {
    const { sortColumn } = this.state;
    const { matchDays } = this.getSortedData();

    return (
      <div>
        <h2>Match Days</h2>
        <Link
          to="/matchdays/new"
          className="btn btn-primary"
          style={{ marginBottom: 20 }}
        >
          <i className="fa fa-file" />
        </Link>
        <MatchDaysTable
          matchDays={matchDays}
          sortColumn={sortColumn}
          onEdit={this.handleEdit}
          onDelete={this.handleDelete}
          onSort={this.handleSort}
        />
      </div>
    );
  }
}

export default MatchDays;



// WEBPACK FOOTER //
// ./src/components/matchDays/matchDays.jsx